import styled from 'styled-components';
import {Space} from 'antd';
import Tabs from '../../components/Tabs';
import DashboardPageTransition from '../../components/animations/DashboardPageTransition';

const CHILDREN_WIDTH = 'calc(61.25% + 12px)';

const StyledSettingPageContainer = styled(DashboardPageTransition)`
  padding: 24px;
`;

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    z-index: 1;
    &:before {
      content: none;
    }
    .ant-tabs-tab {
      &.ant-tabs-tab-active {
        border-color: ${props => props.theme.colors.neutral_4};
        border-bottom-color: transparent;
      }
    }
  }
  .ant-tabs-tabpane {
    .ant-card {
      margin-top: 0;
    }
  }

  .ant-tabs-content-holder {
    background-color: unset;
    border: unset;
    margin-top: -1px;
    min-height: unset;
    padding: unset;
  }
`;

const StyledTabComponentContainer = styled(Space)`
  width: 100%;
  & > div {
    width: 100%;
    & > div {
      width: 100%;
    }
    &:nth-of-type(1) {
      min-width: ${CHILDREN_WIDTH};
      width: ${CHILDREN_WIDTH};
    }
  }
`;

export {
  StyledSettingPageContainer,
  StyledTabs,
  StyledTabComponentContainer
};
